// routes
import { PATH_DASHBOARD } from '../../routes/paths';
// components
import SvgIconStyle from '../../components/SvgIconStyle';

// ----------------------------------------------------------------------

const getIcon = (name) => (
  <SvgIconStyle src={`/static/icons/navbar/${name}.svg`} sx={{ width: '100%', height: '100%' }} />
);

const ICONS = {
  blog: getIcon('ic_blog'),
  cart: getIcon('ic_cart'),
  chat: getIcon('ic_chat'),
  mail: getIcon('ic_mail'),
  user: getIcon('ic_user'),
  media: getIcon('ic_media'),
  question: getIcon('ic_question'),
  truth: getIcon('ic_truth'),
  idea: getIcon('ic_idea'),
  avatar: getIcon('ic_avatar'),
  emoji: getIcon('ic_emoji'),
  subgroup: getIcon('ic_subgroup'),
  option: getIcon('ic_option'),
  kanban: getIcon('ic_kanban'),
  banking: getIcon('ic_banking'),
  calendar: getIcon('ic_calendar'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  booking: getIcon('ic_booking'),
  map: getIcon('ic_map'),
  level: getIcon('ic_level'),
  wallet: getIcon('ic_wallet'),
  location: getIcon('ic_location'),
  settings: getIcon('ic_settings')
};

const sidebarConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: 'general',
    items: [
      {
        title: 'app',
        path: PATH_DASHBOARD.general.app,
        icon: ICONS.dashboard
      }
    ]
  },

  // MANAGEMENT
  // ----------------------------------------------------------------------
  {
    subheader: 'management',
    items: [
      {
        title: 'users',
        path: PATH_DASHBOARD.user.root,
        icon: ICONS.user
      },
      // MANAGEMENT : Question
      {
        title: 'questions',
        path: PATH_DASHBOARD.question.root,
        icon: ICONS.question
      },
      {
        title: 'truth',
        path: PATH_DASHBOARD.truth.root,
        icon: ICONS.truth
      },
      {
        title: 'ideas',
        path: PATH_DASHBOARD.idea.root,
        icon: ICONS.idea
      },
      {
        title: 'options',
        path: PATH_DASHBOARD.options.root,
        icon: ICONS.option,
        children: [
          { title: 'group', path: PATH_DASHBOARD.options.group },
          { title: 'value', path: PATH_DASHBOARD.options.value },
        ]
      },
      {
        title: 'sub_group',
        path: PATH_DASHBOARD.sub_group.root,
        icon: ICONS.subgroup
      },
      // MANAGEMENT : AVATAR
      {
        title: 'avatars',
        path: PATH_DASHBOARD.avatar.root,
        icon: ICONS.avatar
      },
      {
        title: 'emoji',
        path: PATH_DASHBOARD.emoji.root,
        icon: ICONS.emoji
      },
      // MANAGEMENT : Media
      {
        title: 'media',
        path: PATH_DASHBOARD.media.root,
        icon: ICONS.media
      },
      // MANAGEMENT : Levels
      {
        title: 'levels',
        path: PATH_DASHBOARD.level.root,
        icon: ICONS.level
      },
      // MANAGEMENT : Wallet Tokens
      {
        title: 'wallet_tokens',
        path: PATH_DASHBOARD.wallet_token.root,
        icon: ICONS.wallet
      },
      {
        title: 'location',
        path: PATH_DASHBOARD.location.country,
        icon: ICONS.location,
        children: [
          { title: 'country', path: PATH_DASHBOARD.location.country },
          { title: 'state', path: PATH_DASHBOARD.location.state },
          { title: 'city', path: PATH_DASHBOARD.location.city }
        ]
      },
      {
        title: "lets_go_out",
        path: PATH_DASHBOARD.lets_go_out.root,
        icon: ICONS.wallet
      },
      // MANAGEMENT : Settings
      {
        title: 'settings',
        path: PATH_DASHBOARD.settings.root,
        icon: ICONS.settings,
        children: [
          { title: 'account', path: PATH_DASHBOARD.settings.account }
        ]
      },
    ]
  },


];

export default sidebarConfig;
